export default __webpack_public_path__ + "static/media/p2p-banners-bm.8828146f.webp";